import { cn } from "@/lib/utils";
import { Icon, type IconName } from "./icon";

export interface AvatarProps {
  initials: string;
  /** Optional photo URL — when set, the image replaces the initials. */
  src?: string | null;
  /** Optional icon — when set, the glyph is centred in the circle instead of initials/image. */
  icon?: IconName;
  /** Override the icon glyph size in px (defaults to half the circle size). */
  iconSize?: number;
  size?: number;
  className?: string;
}

export function Avatar({ initials, src, icon, iconSize, size = 36, className }: AvatarProps) {
  return (
    <div
      className={cn("avatar", src && "avatar-img", className)}
      style={{ width: size, height: size, fontSize: size * 0.38 }}
    >
      {icon ? <Icon name={icon} size={iconSize ?? size * 0.5} /> : src ? <img src={src} alt="" /> : initials}
    </div>
  );
}
